export default __webpack_public_path__ + "static/media/gallery_02.018217f1.jpg";